import { render, staticRenderFns } from "./setApportion.vue?vue&type=template&id=44ccf4cf&scoped=true"
import script from "./setApportion.vue?vue&type=script&lang=js"
export * from "./setApportion.vue?vue&type=script&lang=js"
import style0 from "./setApportion.vue?vue&type=style&index=0&id=44ccf4cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ccf4cf",
  null
  
)

export default component.exports